import { Heading, Icon, Modal } from "@oysterhr/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export const BankAccountTypeModal = () => {
  const { t } = useTranslation("payments/BankAccountTypeModal")
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Icon
        name="InfoCircle"
        size="sm"
        onClick={() => setIsOpen(true)}
        className="cursor-pointer text-gray-400"
      />

      <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} size="lg">
        <Modal.Header align="center">{t("title")}</Modal.Header>
        <Modal.Content>
          <div className="space-y-6">
            <div>
              <Heading as="h3" size="lg" className="mb-3">
                {t("individual.title")}
              </Heading>
              <ul className="list-disc pl-5 text-gray-400">
                <li>{t("individual.description")}</li>
              </ul>
            </div>
            <div>
              <Heading as="h3" size="lg" className="mb-3">
                {t("business.title")}
              </Heading>
              <ul className="list-disc pl-5 text-gray-400">
                <li>{t("business.description")}</li>
              </ul>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    </>
  )
}
